<template>
  <div class="bandeau">
    <small>
      Service d'envoi de courrier de résiliation, indépendamment de {{ label }}.
    </small>
  </div>
</template>

<script>
export default {
  props: {
    showRgpd: Boolean,
    description: String,
    type: String
  },
  computed: {
    label () {
      return this.type === 'mutuelle' ? 'la société d\'assurance' : 'l\'opérateur'
    }
  }
}
</script>

<style lang="scss" scoped>
  .bandeau {
    padding: 3px;
    line-height: 100%;
    background: black;
    color: white;
    font-size: 14px;
    text-align: center;
  }
  .el-button {
    padding: 0;
  }

  @media (max-width: 767px) {
    .bandeau {
      font-size: 11px;
      line-height: 14px;
      padding: 5px 20px;
      height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/bandeau.vue